import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { isAuthenticated } from 'utils/authUtils';

const PublicRoute = ({ component, path }: any) => {
  // Use enhanced authentication check
  const authenticated = isAuthenticated();

  // Splash, landing, and articles stay reachable when logged in.
  const publicStayPaths = ['/', '/home', '/articles', '/articles/:id'];
  if (authenticated && !publicStayPaths.includes(path)) {
    return <Redirect to="/dashboard" />;
  }

  const isDynamicRoute = typeof path === 'string' && path.includes(':');
  return <Route exact={!isDynamicRoute} path={path} component={component} />;
};

export default PublicRoute;
